import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Tone = 'default' | 'danger';
type Size = 'sm' | 'md';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
  tone?: Tone;
  size?: Size;
  label?: string;
};

const sizes: Record<Size, number> = { sm: 26, md: 30 };

const IconButton = ({
  icon,
  tone = 'default',
  size = 'md',
  label,
  disabled,
  style,
  ...rest
}: IconButtonProps) => {
  const baseColor =
    tone === 'danger' ? 'var(--shell-semantic-error)' : 'var(--shell-text-secondary)';
  const hoverBg = tone === 'danger' ? 'rgba(185, 28, 28, 0.08)' : 'var(--shell-bg-hover)';

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      disabled={disabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: sizes[size],
        height: sizes[size],
        borderRadius: 'var(--shell-radius-md)',
        border: 'none',
        background: 'transparent',
        color: disabled ? 'var(--shell-text-tertiary)' : baseColor,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background var(--shell-transition-fast), color var(--shell-transition-fast)',
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!disabled) (e.currentTarget as HTMLElement).style.background = hoverBg;
      }}
      onMouseLeave={(e) => {
        if (!disabled) (e.currentTarget as HTMLElement).style.background = 'transparent';
      }}
      {...rest}
    >
      {icon}
    </button>
  );
};

export default IconButton;
